import { Link, useSearchParams } from 'react-router-dom';
import ApproveIcon from 'src/images/icons/cart-approved-icon.svg?react';

type Props = {
  cartRequestedBy: string; // this will be their name, if no name then email
};

export const ReviewApproved = ({ cartRequestedBy }: Props) => {
  const [searchParams] = useSearchParams();
  const isAdditionalApproval =
    searchParams.get('additional_approval') === 'true';

  return (
    <div className='flex w-full flex-col items-center justify-center gap-6 bg-primary-dark py-16 sm:gap-8 sm:py-20 md:gap-10 md:py-24 lg:gap-12 lg:py-28'>
      <div className='flex w-full max-w-[650px] flex-col items-center justify-center gap-2 sm:gap-3 md:gap-4 lg:gap-6'>
        <ApproveIcon />
        <h5 className='heading-500 text-pretty text-center text-offWhite'>
          {isAdditionalApproval
            ? 'Cart Approved and Sent for Additional Approval!'
            : 'Cart Approved!'}
        </h5>
        <p className='text-300 text-balance text-center text-blueGray'>
          {isAdditionalApproval
            ? `We've sent an email to the next approver to let them know the cart requires additional approval.`
            : `We've sent an email to ${cartRequestedBy} to let them know the
          cart has been approved and is ready to go!`}
        </p>
      </div>

      <Link to='/plus/cart-history'>
        <button className='button-primary h-12'>View All Carts</button>
      </Link>
    </div>
  );
};
